import { render, staticRenderFns } from "./ClipboardComposer.vue?vue&type=template&id=c2d6786e&scoped=true"
import script from "./ClipboardComposer.vue?vue&type=script&lang=js"
export * from "./ClipboardComposer.vue?vue&type=script&lang=js"
import style0 from "./ClipboardComposer.vue?vue&type=style&index=0&id=c2d6786e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d6786e",
  null
  
)

export default component.exports